import { useState } from 'react';
import { createApiClient } from '@shared/api/client/api-client';
import { createAuthApi } from '@shared/api/lib/auth-api';
import { env } from '@shared/config/env';
import { mapPasswordApiError, type PasswordApiFailure } from '@entities/auth';

export const useForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);

  const requestLink = async (
    email: string,
  ): Promise<{ success: true } | { success: false; failure: PasswordApiFailure | null }> => {
    setIsLoading(true);

    try {
      const authApi = createAuthApi(createApiClient({ baseURL: env.API_BASE_URL }));
      await authApi.forgotPassword({ email });
      return { success: true };
    } catch (error: unknown) {
      return { success: false, failure: mapPasswordApiError(error) };
    } finally {
      setIsLoading(false);
    }
  };

  return { requestLink, isLoading };
};
